import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NumericRule } from 'devextreme/ui/validation_rules';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { Lookup } from 'src/app/common/model/lookup';
import { LookupService } from 'src/app/common/service/lookup.service';
import { FacilityService } from '../services/facility.service';
import { CurrencyConversion } from '../types/CurrencyConversion';
import { Facility } from '../types/Facility';
@Component({
  selector: 'currency-conversion',
  templateUrl: './currency-conversion.component.html',
  styleUrls: ['./currency-conversion.component.scss']
})
export class CurrencyConversionComponent implements OnInit {
  @Input() currencyConversionPopupVisible: Boolean;
  @Input() facility: Facility;
  @Output() closeEvent = new EventEmitter<boolean>();
  isLoadPanelVisible: boolean = false;
  currencies: Lookup[] = [];
  exchangeRateYear: number;
  exchangeYears: number[];
  destinationCurrency: string;
  currencyConversion: CurrencyConversion = {
    capitalInvestment: '',
    gasifierCapital: '',
    asuCapital: '',
    smrCapital: '',
    hydrogenOtherCapital: ''
  };
  constructor(private facilityService: FacilityService, private lookupService: LookupService, private notificationService: NotificationService) {

  }

  ngOnInit(): void {
    this.lookupService.getLookupValues('Currency')
      .subscribe(
        (data: Lookup[]) => {
          this.currencies = data
        }
      );

    this.facilityService.GetCurrencyExchangeYears()
      .subscribe(
        (data: number[]) => {
          this.exchangeYears = data
        }
      );
  }

  close() {
    this.closeEvent.emit(false);
  }

  convertCurrency() {
    if (this.facility.facilityDetail.currency === this.destinationCurrency) {
      this.notificationService.alert("warning", "Source and Destination currencies can't be same", null);
      return;
    }
    if (this.facility.facilityDetail.currency !== 'USD' && this.destinationCurrency !== 'USD') {
      this.notificationService.alert("warning", "Not supported operation", null);
      return;
    }

    this.isLoadPanelVisible = true;
    this.facilityService.ConvertCurrency(this.facility.productionFacilityId, this.exchangeRateYear, this.facility.facilityDetail.currency, this.destinationCurrency)
      .subscribe(
        (data: CurrencyConversion) => {
          this.currencyConversion = data;
          this.isLoadPanelVisible = false;
        }
      );

  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

}